const common = require("./_common")

// PasswordReset

module.exports = {
  title: {
    en: "Password Reset",
    fr: "Réinitialisation de mot de passe"
  },
  newPassword: {
    en: "New password",
    fr: "Nouveau mot de passe"
  },
  confirmPass: {
    en: "Confirm password",
    fr: "Confirmer le mot de passe"
  },
  ...common.passwordError,
  differentPasswords: {
    en: "The two passwords are different",
    fr: "Les mots de passes sont différents"
  },
  submit: {
    en: "Reset",
    fr: "Réinitialiser"
  },
  msgAlertTitle: {
    en: "Your password is being updated",
    fr: "Ce mot de passe a été pris en compte"
  },
  msgAlertText: {
    en: "Your password will be ready to use in a few seconds, you can access the login page by clicking on the 'close' button",
    fr: "Votre mot de passe sera utilisable d'ici quelques secondes, vous pouvez d'hors et déjà acceder au site principal en cliquant sur le bouton 'Quitter la page'"
  },
  msgAlertErrorTitle: {
    en: "An error has occured",
    fr: "Une erreur à eu lieu"
  },
  msgAlertErrorText: {
    en: "Contact your administrator to regenerate a new token",
    fr: "Contactez votre administrateur pour obtenir un nouveau token"
  },
  msgAlertErrorTitle498: {
    en: "Token expired",
    fr: "Jeton expiré"
  },
  msgAlertErrorText498: {
    en: "Contact your administrator to regenerate a new valid token non expiré",
    fr: "Contactez votre administrateur pour obtenir un nouveau token non expiré"
  },
  msgAlertErrorTitle400: {
    en: "Token invalid",
    fr: "Jeton invalide"
  },
  msgAlertErrorText400: {
    en: "Contact your administrator to regenerate a new valid token",
    fr: "Contactez votre administrateur pour obtenir un nouveau token valide"
  }
}